var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"overflow-hidden\">\r\n<div id=\"vue-cvu-transfer-data-panel\"/>\r\n\r\n</div>\r\n";
},"useData":true});